const SOCKET_CONTROL_LOGINS = [
  "anderson.dacampo",
  "paulo.cervelin",
  "solane.bernardy",
];

const getRoles = (user) => {
  if (!user || !Array.isArray(user.roles)) {
    return [];
  }

  return user.roles;
};

const hasProject = (roles, projectId) =>
  roles.some((role) => role.projectid == projectId);

const hasSocketControlsAccess = (login) =>
  SOCKET_CONTROL_LOGINS.includes(login);

export const getSidebarPermissions = (user) => {
  const roles = getRoles(user);
  const login = user && user.login ? user.login : "";

  return {
    accessSySafra: hasProject(roles, 250),
    accessSocketControls: hasSocketControlsAccess(login),
    hasProject257: hasProject(roles, 257),
    hasProject306: hasProject(roles, 306),
  };
};

export default {
  getSidebarPermissions,
};
